export default __webpack_public_path__ + "static/form-visible-label-do-2bd82df00b91e40a3a234f99c82bd42b.png";